import assign from 'lodash/assign';

import Constants from 'app/shared/constants';
import PropertiesConstants from 'app/shared/constants/PropertiesConstants';

const initState = () => ({
    // listings endpoint parameters - initState set to defaults
    includeActive: Constants.PROPERTIES_ACTIVE_DEFAULT,
    includeInactive: Constants.PROPERTIES_INACTIVE_DEFAULT,
    searchText: Constants.PROPERTIES_SEARCHTEXT_DEFAULT,
    feeds: Constants.PROPERTIES_FEEDS_DEFAULT,
    manual: Constants.PROPERTIES_MANUAL_DEFAULT,
    ascending: Constants.PROPERTIES_ASCENDING_DEFAULT,
    sort: Constants.PROPERTIES_SORT_DEFAULT,
    featured: Constants.PROPERTIES_FEATURED_DEFAULT,
    startKeyExclusive: Constants.PROPERTIES_START_KEY_EXCLUSIVE_DEFAULT,
    limit: Constants.PROPERTIES_LIMIT_DEFAULT,
    includeArchived: Constants.PROPERTIES_INCLUDE_ARCHIVED,
    includeUnarchived: Constants.PROPERTIES_INCLUDE_UNARCHIVED,
    viewType: PropertiesConstants.PROPERTIES_VIEW_TYPE.GRID,
    subNavFilterType: PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ALL,
});

const propertiesFilters = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case Constants.UPDATE_PROPERTIES_FILTERS:
            return assign({}, state, payload);

        default:
            return state;
    }
};

export default propertiesFilters;
